<script lang="ts">
	//Services
	import { format } from '../../../../../services/i18n';
	//Helpers
	import { formatSnakeCaseToTitle } from '../../../../../helpers/utilities';
	//Design system components
	import { Radio, Text } from '@Shelly/shelly-design-system';

	export let typeValue;

	let options = ['button', 'switch'];
	let _options = [$format('working_type_button'), $format('working_type_switch')];

	let value = typeValue;
	$: typeValue = value;
</script>

<Text class="text-bold mb-s">
	{formatSnakeCaseToTitle($format('btn_type_label'))}
</Text>

{#each options as option, i}
	<Radio size="m" class="mb-s" bind:selected={value} value={option} id="radio-8huol5i">
		{_options[i]}
	</Radio>
{/each}
